import axios from 'axios';
import { hasAuthAccessParams } from '../types/guards';
import { processResponse, processError, privateRequestParams } from '../utils';
export default class HeroPillsAPI {
    static getSchedules(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_ENDPOINT + 'frontend/pills-by-schedules/', privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static editSchedules(accessParams, payload) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .patch(accessParams.API_ENDPOINT + 'frontend/user-config-d2d-modify-schedule-time/', payload, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map